import DiskTemplate from '../../templates/settings/ui/disk';
import quotaRequest from '../../../../shared/api/quota/request';
import { useEffect, useState } from 'react';

export default function Disk() {
  const [quota, setQuota] = useState(0);
  const [used, setUsed] = useState(0);
  const [days, setDays] = useState('  ');
  useEffect(() => {
    quotaRequest().then((data) => {
      setQuota(data.quota);
      setUsed(data.used);
      setDays(data.availableRecordingsDays + '');
    });
  });
  return <DiskTemplate days={days} used={used} quota={quota} />;
}
